import type { LockerRoom } from '@/types';

/**
 * Per-room visual identity: Male = steel blue, Female = dusty rose. The hues
 * are deliberately muted so the amber "key out" state always reads first; the
 * room tint answers "which room am I in" from any element on screen. Full
 * class strings (not interpolated) so Tailwind's scanner keeps them.
 */
export const ROOM_THEME: Record<LockerRoom, {
  /** Active room tab. */
  tab: string;
  /** Free locker tile (occupied tiles stay amber in both rooms). */
  tile: string;
  /** Small "Male 7" chip used in tables and modals. */
  chip: string;
  /** Room name text. */
  name: string;
  /** Occupancy meter fill. */
  meter: string;
  /** Grid-card header wash behind the room label. */
  wash: string;
}> = {
  male: {
    tab: 'bg-blue-50 text-blue-800 border-b-blue-700',
    tile: 'border-blue-200 bg-white text-gray-700 hover:border-blue-400 hover:bg-blue-50',
    chip: 'bg-blue-50 text-blue-800 border-blue-200',
    name: 'text-blue-800',
    meter: 'bg-blue-700',
    wash: 'bg-blue-50/60',
  },
  female: {
    tab: 'bg-rose-50 text-rose-800 border-b-rose-700',
    tile: 'border-rose-200 bg-white text-gray-700 hover:border-rose-400 hover:bg-rose-50',
    chip: 'bg-rose-50 text-rose-800 border-rose-200',
    name: 'text-rose-800',
    meter: 'bg-rose-700',
    wash: 'bg-rose-50/60',
  },
};
